import {createContext, useState} from 'react'

interface AprobacionAnyContextProps {
  unidad: string
  setUnidad: (unidad: string) => void
  idProceso: string
  setIdProceso: (idProceso: string) => void
  searchTerm: string
  setSearchTerm: (searchTerm: string) => void
  Dates: [Date | null, Date | null]
  setDates: (dates: [Date | null, Date | null]) => void
  sortBy: {columnName: string; sortDirection: string}
  setSortBy: (sortBy: {columnName: string; sortDirection: string}) => void
  page: number
  setPage: (page: number) => void
  totalPages: number
  setTotalPages: (totalPages: number) => void
  assignedProcesses: any[]
  setAssignedProcesses: (assignedProcesses: any[]) => void
  assignedUnits: any[]
  setAssignedUnits: (assignedUnits: any[]) => void
  permissions: any[]
  setPermissions: (permissions: any[]) => void
  packages: any[]
  setPackages: (packages: any[]) => void
  loading: boolean
  setLoading: (loading: boolean) => void
}

export const AprobacionAnyContext = createContext<AprobacionAnyContextProps>({
  // FOR FILTERS
  unidad: '',
  setUnidad: () => {},
  idProceso: '',
  setIdProceso: () => {},
  searchTerm: '',
  setSearchTerm: () => {},
  Dates: [null, null],
  setDates: () => {},
  sortBy: {columnName: '', sortDirection: ''},
  setSortBy: () => {},

  // FOR PAGINATION
  page: 1,
  setPage: () => {},
  totalPages: 1,
  setTotalPages: () => {},

  // FOR TABLE AND COMBOBOX
  assignedProcesses: [],
  setAssignedProcesses: () => {},
  assignedUnits: [],
  setAssignedUnits: () => {},
  permissions: [],
  setPermissions: () => {},
  packages: [],
  setPackages: () => {},

  loading: false,
  setLoading: () => {},
})

export const AprobacionAnyProvider = ({children}: {children: React.ReactNode}) => {
  const [unidad, setUnidad] = useState('')
  const [idProceso, setIdProceso] = useState('')
  const [searchTerm, setSearchTerm] = useState('')
  const [Dates, setDates] = useState<[Date | null, Date | null]>([null, null])
  const [sortBy, setSortBy] = useState<{columnName: string; sortDirection: string}>({
    columnName: '',
    sortDirection: '',
  })
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [permissions, setPermissions] = useState<any[]>([])
  const [assignedProcesses, setAssignedProcesses] = useState<any[]>([])
  const [assignedUnits, setAssignedUnits] = useState<any[]>([])
  const [packages, setPackages] = useState<any[]>([])
  const [loading, setLoading] = useState(false)

  return (
    <AprobacionAnyContext.Provider
      value={{
        unidad,
        setUnidad,
        idProceso,
        setIdProceso,
        searchTerm,
        setSearchTerm,
        Dates,
        setDates,
        page,
        setPage,
        totalPages,
        setTotalPages,
        sortBy,
        setSortBy,
        packages,
        setPackages,
        permissions,
        setPermissions,
        assignedProcesses,
        setAssignedProcesses,
        assignedUnits,
        setAssignedUnits,
        loading,
        setLoading,
      }}
    >
      {children}
    </AprobacionAnyContext.Provider>
  )
}
